import React, { FC, MouseEvent, useContext } from "react";
import { UserContext } from "@ipd/js-common";
import { makeStyles } from "@material-ui/styles";
import { PERMISSIONS } from "../../constants";
import { usePermissions } from "../../hooks";
import { VisibilityContext } from "../../context";
import NoAccess from "./NoAccess";
import Marketing from "./Marketing";

const useStyles = makeStyles(() => ({
  disabled: {
    filter: "brightness(0.85)",
  },
}));

const PermissionModal: FC = ({ children }) => {
  const classes = useStyles();

  const hasPermission = usePermissions({ ...PERMISSIONS.APP, ...PERMISSIONS.PPI });
  const { isLoggedIn } = useContext(UserContext);
  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  if (!isLoggedIn) return null;
  if (!hasPermission || visibilityContext.marketing) {
    return (
      <>
        {!hasPermission && <NoAccess />}
        {visibilityContext.marketing && <Marketing />}
        <div className={classes.disabled} onClickCapture={handleClick}>
          <>{children}</>
        </div>
      </>
    );
  } else {
    return <>{children}</>;
  }
};

export default PermissionModal;
